define([], () =>
        (QuickQuoteService, tileModel, previousModel)=> {
            let state = undefined;
            let previousQuote = undefined;
            let previousEmail = undefined;
            let previousSubmission = undefined;

            function reviseQuote() {
                toEdit();
            }

            function toEdit() {
                state = {
                    'id': 'edit',
                    data: {
                        onQuote: startQuote,
                        get completedSteps() {
                            return tileModel.completedSteps;
                        },
                        get allStepsComplete() {
                            return tileModel.completedSteps.every(isComplete => isComplete);
                        }
                    }
                };
                tileModel.viewModel.quotedSubmission = null;
            }

            function proceedToFullQuote() {
                state = {
                    'id': 'proceedToFullQuote'
                };
            }

            function startQuote() {
                /*  Ignore if not in edit mode and the model is invalid. If the user has already a previous quote and
                 *  the submission data hasn't changed, then we reuse the previous quote
                 */
                if (state.id !== 'edit' && !tileModel.viewModel.aspects.valid) {
                    return;
                } else if (angular.equals(previousModel, tileModel.viewModel.value)) {
                    _handleNoChangeOnRequote();
                    return;
                }

                // Copy previous additional details which will be checked to ensure
                // the quote is not requested if no details have changed
                previousModel = angular.copy(tileModel.viewModel.value);

                const quoteProcess = QuickQuoteService.createSubmission('quoteandbind', tileModel.viewModel.value);
                state = {
                    'id': 'quoting',
                    'data': {
                        'process': quoteProcess
                    }
                };

                quoteProcess.then(_handleQuoteSuccess, _handleQuoteFailure);

                function _handleNoChangeOnRequote() {
                    if (previousQuote) {
                        tileModel.viewModel.quotedSubmission = previousSubmission;
                        state = {
                            'id': 'quoted',
                            'data': {
                                'quote': previousQuote,
                                'contactEmail': previousEmail,
                                onRevise: reviseQuote,
                                onNext: proceedToFullQuote
                            }
                        };
                    } else {
                        state = {
                            'id': 'quoteError'
                        };
                    }
                }

                function _handleQuoteSuccess(data) {
                    if (state.data.process !== quoteProcess) {
                        return;
                    }
                    tileModel.viewModel.quotedSubmission = data;
                    tileModel.viewModel.value.submissionNumber = data.quoteID;
                    // Save previous quote in case user goes back and doesn't change submission
                    previousModel.submissionNumber = data.quoteID;
                    previousEmail = data.bindData.contactEmail;
                    previousSubmission = data;
                    previousQuote = {
                        'reference': data.quoteID,
                        'premiumPerMonth': data.quoteData.offeredQuotes[0].monthlyPremium,
                        'premiumPerYear': data.quoteData.offeredQuotes[0].total,
                        'termType': data.draftData.termType,
                        'sessionUUID': data.sessionUUID
                    };
                    state = {
                        'id': 'quoted',
                        'data': {
                            'quote': previousQuote,
                            'contactEmail': previousEmail,
                            onRevise: reviseQuote,
                            onNext: proceedToFullQuote
                        }
                    };
                }

                function _handleQuoteFailure() {
                    if (state.data.process !== quoteProcess) {
                        return;
                    }
                    state = {
                        'id': 'quoteError'
                    };
                    tileModel.viewModel.quotedSubmission = null;
                }
            }

            toEdit();

            return {
                get state() {
                    return state;
                },
                startQuoting: ()=> {
                    startQuote();
                }
            };
        }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/quote/models/QuickQuoteTile.js
 **/